import {ComponentProps, useMemo} from "react";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useAppSelector} from "../../../store/hooks";
import {leadTopicConfig} from "../../constants/lead/lead_topic_config";
import {useLeadFormCloseTracking} from "../../hooks/use_lead_form_close_tracking";
import {LeadTopicType} from "../../types/lead/LeadTopicType";
import {LeadFormWithTopic} from "../lead_form/LeadFormWithTopic";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Pick<ComponentProps<typeof LeadFormWithTopic>, "handleModalClose" | "onSuccessfulSubmit" | "initialLeadFormValues">;

export const LeadFormModalWithTopic = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues} = props;
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose);
    const topic = useAppSelector((state) => state.mainLead.topic);

    const {title, message} = useMemo(() => {
        // If a custom title and message are provided, use them
        if (topic.type === LeadTopicType.CUSTOM && topic.title && topic.message) {
            return {
                title: topic.title,
                message: topic.message
            };
        }

        // Otherwise use predefined config
        if (topic.type && topic.type !== LeadTopicType.CUSTOM && topic.type in leadTopicConfig) {
            return leadTopicConfig[topic.type as LeadTopicType];
        }

        // Fallback to empty strings
        return {
            title: "",
            message: ""
        };
    }, [topic]);

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalCloseWithTracking}
            title={title}
            containerClassName={containerStyles}
            titleClassName={titleStyles}
            testId={OFFER_TEST_IDS.LEAD_FORM.TOPIC_FORM}
        >
            <LeadFormWithTopic
                handleModalClose={handleModalCloseWithTracking}
                onSuccessfulSubmit={onSuccessfulSubmit}
                initialLeadFormValues={initialLeadFormValues}
                customHeader={null}
                defaultMessage={message}
            />
        </LeadFormModalWrapper>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "556px",
        h: "auto",
        overflow: "visible"
    }
});

const titleStyles = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});
import {ComponentProps, useMemo} from "react";
import {css} from "@panda/css";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useAppSelector} from "../../../store/hooks";
import {leadTopicConfig} from "../../constants/lead/lead_topic_config";
import {useLeadFormCloseTracking} from "../../hooks/use_lead_form_close_tracking";
import {LeadTopicType} from "../../types/lead/LeadTopicType";
import {LeadFormWithTopic} from "../lead_form/LeadFormWithTopic";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Pick<ComponentProps<typeof LeadFormWithTopic>, "handleModalClose" | "onSuccessfulSubmit" | "initialLeadFormValues">;

export const LeadFormModalWithTopic = (props: IProps) => {
    const {handleModalClose, onSuccessfulSubmit, initialLeadFormValues} = props;
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose);
    const topic = useAppSelector((state) => state.mainLead.topic);

    const {title, message} = useMemo(() => {
        // If a custom title and message are provided, use them
        if (topic.type === LeadTopicType.CUSTOM && topic.title && topic.message) {
            return {
                title: topic.title,
                message: topic.message
            };
        }

        // Otherwise use predefined config
        if (topic.type && topic.type !== LeadTopicType.CUSTOM && topic.type in leadTopicConfig) {
            return leadTopicConfig[topic.type as LeadTopicType];
        }

        // Fallback to empty strings
        return {
            title: "",
            message: ""
        };
    }, [topic]);

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalCloseWithTracking}
            title={title}
            containerClassName={containerStyles}
            titleClassName={titleStyles}
            testId={OFFER_TEST_IDS.LEAD_FORM.TOPIC_FORM}
        >
            <LeadFormWithTopic
                handleModalClose={handleModalCloseWithTracking}
                onSuccessfulSubmit={onSuccessfulSubmit}
                initialLeadFormValues={initialLeadFormValues}
                customHeader={null}
                defaultMessage={message}
            />
        </LeadFormModalWrapper>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "556px",
        h: "auto",
        overflow: "visible"
    }
});

const titleStyles = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});
